const { logLevels, formatMessage } = require('../helpers');

/**
 * @typedef {import('../helpers')} LogLevel
 */

/**
 *
 * @param {object[]} message(s)
 * @param {object} [userContext] Context to include in structured logs
 * @param {string} userContext.tenantId
 * @param {object} [userContext.activeTenant]
 * @param {string} userContext.appId
 * @param {object} [userContext.appContext]
 * @param {string} userContext.userId
 * @param {string} userContext.userName
 * @param {LogLevel} logLevel Level to log message with
 */
function output(message, userContext = {}, logLevel) {
    const formattedMessage = formatMessage(message, userContext, logLevel);
    const _message = typeof formattedMessage === 'object' ? JSON.stringify(formattedMessage) : formattedMessage;
    switch (logLevel) {
        case logLevels.ERROR:
            console.error(_message);
            break;
        case logLevels.WARN:
            console.warn(_message);
            break;
        case logLevels.INFO:
            console.info(_message);
            break;
        case logLevels.DEBUG:
            console.log(_message);
            break;
    }
}

module.exports = {
    output
};
